import html2canvas from "html2canvas";

import EditorController from "./editor";

export default class extends EditorController {
  static targets = ['image']

  connect() {
    super.connect();

    this.form = this.element.closest('form')
    this.form.addEventListener('submit', this.setImage.bind(this))

    console.log("SUPER")
  }


  setImage(e) {
    if (this.canvasImage) return;

    e.preventDefault()

    this.canvasImage = true

    document.querySelector('.page__body').style.opacity = 0

    this.element.querySelector('.editor__container').style.width = '1920px'
    this.element.querySelector('.editor__container').style.height = '1080px'

    this.canvasViewportTarget.style.width = '1920px'
    this.canvasViewportTarget.style.height = '1080px'
    this.canvasViewportTarget.removeAttribute('data-editor-target')

    this.canvasScalerTarget.style.transform = 'none'
    this.canvasScalerTarget.removeAttribute('data-editor-target')

    this.canvasTarget.style.transform = 'none'
    this.canvasTarget.removeAttribute('data-editor-target')

    this.element.querySelector('.editor__selected')?.classList.remove('editor__selected')


    html2canvas(this.element.querySelector('.editor__container'), {
      width: 1920,
      height: 1080,
      scale: 2
    }).then(canvas => {
      canvas.toBlob((blob) => {
        if (!blob) return;

        // 1. Maak een echt File object van de Blob
        const file = new File([blob], "canvas-afbeelding.png", { type: "image/png" });

        // 2. Maak een DataTransfer object aan (dit simuleert een drag-and-drop actie)
        const dataTransfer = new DataTransfer();

        // 3. Voeg de file toe aan de DataTransfer
        dataTransfer.items.add(file);

        // 4. Wijs de resulterende FileList toe aan de file input
        this.imageTarget.files = dataTransfer.files;

        this.form.requestSubmit();

      }, 'image/png');

    })
  }
}